<script setup>
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore, useMapGetter } from 'dashboard/composables/store';

import Button from 'dashboard/components-next/button/Button.vue';
import AddToFunnelDialog from './AddToFunnelDialog.vue';

const props = defineProps({
  contactId: {
    type: [Number, String],
    required: true,
  },
  conversationId: {
    type: [Number, String],
    required: true,
  },
});

const { t } = useI18n();
const store = useStore();
const dialogRef = ref(null);

const cardsGetter = useMapGetter('funnels/getCardsForContact');
const cards = computed(() => cardsGetter.value(props.contactId));

watch(
  () => props.contactId,
  contactId => {
    if (contactId) store.dispatch('funnels/fetchContactCards', { contactId });
  },
  { immediate: true }
);

const openDialog = () => dialogRef.value?.open();
</script>

<template>
  <div class="px-4 py-3">
    <div v-if="cards.length" class="flex flex-col gap-2 mb-2">
      <div
        v-for="card in cards"
        :key="card.id"
        class="flex items-center justify-between px-3 py-2 text-sm border rounded-lg border-n-weak"
      >
        <span class="font-medium text-n-slate-12">{{ card.funnel_name }}</span>
        <span class="text-n-slate-11">{{ card.funnel_stage_name }}</span>
      </div>
    </div>
    <Button
      sm
      faded
      slate
      icon="i-lucide-plus"
      justify="center"
      class="w-full"
      :label="t('FUNNELS.ADD_TO_FUNNEL.ACTION')"
      @click="openDialog"
    />
    <AddToFunnelDialog ref="dialogRef" :conversation-id="conversationId" />
  </div>
</template>
